import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '@morpho-org/ui-v6/utils';
import { Icon } from '@repo/ui';
import { pluralize } from '@repo/utils';
import { LinkifiedText } from '@/components/common/LinkifiedText';
import { scrollToElementAfterDelay } from '@/helpers/scrollToElement';
import { getWarningLevelBgClass, getWarningLevelColorClass, getWarningLevelIcon, sortWarningsByLevel, type UnifiedVaultWarningLevel } from '@/helpers/warnings';
import { getWarningNavigationConfig } from '../warningNavigationConfig';
export interface Warning {
  level: UnifiedVaultWarningLevel;
  message: string | ReactNode;
  warningType?: string;
  entity?: ReactNode;
}
export interface WarningHoverCardContentProps {
  warnings: Warning[];
  isSimple: boolean;
  onClose: () => void;
}
const WarningHoverCardContent = t0 => {
  const $ = _c(20);
  const {
    warnings,
    isSimple,
    onClose
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== isSimple || $[1] !== onClose || $[2] !== warnings) {
    const sortedWarnings = sortWarningsByLevel(warnings, "desc");
    const warningsCountLabel = pluralize(sortedWarnings.length, "active warning");
    let t6;
    if ($[8] !== onClose) {
      t6 = warningType => {
        const config = getWarningNavigationConfig(warningType);
        if (!config) {
          return;
        }
        onClose();
        scrollToElementAfterDelay(config.elementId);
      };
      $[8] = onClose;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    const handleWarningClick = t6;
    t3 = "gap-xs p-sm flex max-h-[300px] flex-col overflow-auto";
    t4 = _temp;
    t5 = !isSimple && <span className="text-foreground text-sm">{warningsCountLabel}</span>;
    t1 = "gap-xs flex flex-col";
    let t7;
    if ($[10] !== handleWarningClick) {
      t7 = (warning, index) => {
        const colorClass = getWarningLevelColorClass(warning.level);
        const levelIcon = getWarningLevelIcon(warning.level);
        const config_0 = getWarningNavigationConfig(warning.warningType);
        const isClickable = !!config_0;
        return <div key={index} className={cn("gap-2xs p-xs flex items-start rounded-lg", getWarningLevelBgClass(warning.level) ?? "bg-muted", isClickable && "transition-opacity hover:opacity-80 cursor-pointer")} onClick={() => handleWarningClick(warning.warningType)}><div className="gap-2xs flex flex-col items-start"><div className="gap-2xs flex flex-row items-start"><Icon icon={levelIcon} className={colorClass} /><span className={cn("text-xs", colorClass)}>{typeof warning.message === "string" ? <LinkifiedText text={warning.message} /> : warning.message}</span></div>{warning.entity}</div></div>;
      };
      $[10] = handleWarningClick;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t2 = sortedWarnings.map(t7);
    $[0] = isSimple;
    $[1] = onClose;
    $[2] = warnings;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className={t3} onClick={t4}>{t5}{t6}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default WarningHoverCardContent;
function _temp(e) {
  e.stopPropagation();
}